import { AuthenticateResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import AuthenticatedUserContext from '@/contexts/authentication/AuthenticatedUserContext';
import useAuthenticatedUser from '@/hooks/authentication/useAuthenticatedUser';
import { useTheme } from '@mui/material';
import { FC, PropsWithChildren } from 'react';



export interface IAuthenticatedUserProviderProps {
    initial?: AuthenticateResponse | null;
}


export const AuthenticatedUserProvider: FC<PropsWithChildren<IAuthenticatedUserProviderProps>> = ({ initial, children }) => {
    const authenticatedUser = useAuthenticatedUser({ revalidateOnFocus: true, errorRetryCount: 0,  refreshInterval: 600000, fallbackData: initial});

    const theme = useTheme();

    if (!authenticatedUser.loading && !authenticatedUser.validating && !authenticatedUser.data) {
        let pathName = location.pathname;

        if (pathName.startsWith('/,https://')) {
            let pathNameParts = pathName.split('/');

            if (pathNameParts.length > 4) {
                pathName = '/' + pathNameParts.slice(4).join('/');
            }
            else {
                pathName = '/';
            }
        }

        window.location.href = `/auth/openiddict?redirect=${encodeURIComponent(pathName + location.search)}&theme=${theme.palette.mode}`

        return null;
    }

    // if (!!authenticatedUser.data && !authenticatedUser.data.roles?.includes('BctStaff')) {
        
    //     return (
    //         <BasicAlert
    //             severity="error"
    //             title={'403 Forbidden'}
    //             description={"User does not have the required permissions to view this resource."}
    //             icon={faExclamationTriangle}
    //         />
    //     )
    // }

    if (!authenticatedUser?.data) {
        return null;
    }

    return (
        <AuthenticatedUserContext.Provider value={authenticatedUser}>
            <IsLoading name="authenticated-user" loading={authenticatedUser.loading} validating={authenticatedUser.validating}/>
            {children}
        </AuthenticatedUserContext.Provider>
    );
}

export default AuthenticatedUserProvider;
